declare global {
    interface Window {
        dataLayer: any[];
    }
}

export function pushDL(event: string, payload: Record<string, any> = {}) {
    if (!window.dataLayer) window.dataLayer = [];
    window.dataLayer.push({ event, ...payload });
}
